import React from 'react';
import { Table } from 'semantic-ui-react';

export default function AreaTableHeaderCell(): React.ReactElement {
    return <Table.HeaderCell className="table-header-cell area" />;
}
